export default "/bundles/assets/attachment_text_1c2b6d1bce1f38b88467d88d0b013d6b.png";